import { createFileRoute, useParams } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";
import { Separator } from "@/components/ui/separator";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";

import { APP_ID } from "../-constant";
import { useAppIntegrationContract } from "../-query";

import { InnerNavigation } from "./-components/InnerNavigation";
import Authentication from "./-components/sections/authentication";
import CustomAppDefinition from "./-components/sections/custom-app-definition";
import DangerZone from "./-components/sections/danger-zone";
import IntegrationFeatures from "./-components/sections/integration-features";
import PlanDetails from "./-components/sections/plan-details";
import PlanDetailsCustomApp from "./-components/sections/plan-details-customapp";
import PricingBillingPlan from "./-components/sections/pricing-billing-plan";
import SamlSso from "./-components/sections/saml-sso";

export const Route = createFileRoute(
  "/_staff/app-integrations/$id/_$id/settings/",
)({
  component: Settings,
});

function Settings() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.profile.app.settings",
  });
  const { id } = useParams({
    from: "/_staff/app-integrations/$id/_$id",
  });
  const { data: appIntegrationData } = useAppIntegrationContract(id);
  const { integratedApp } = appIntegrationData;

  useDocumentTitle(
    t("pageTitle", {
      name: integratedApp.name,
      interpolation: { escapeValue: false },
    }),
  );

  return (
    <div
      className="grid h-full gap-10 pb-24 mx-auto mt-6"
      style={{ gridTemplateColumns: "240px 1024px" }}
    >
      <div className="relative pl-4">
        <InnerNavigation />
      </div>
      <div className="overflow-y-auto">
        <SettingItems />
      </div>
    </div>
  );
}

function SettingItems() {
  const { id } = useParams({
    from: "/_staff/app-integrations/$id/_$id",
  });
  const { data: appIntegrationData } = useAppIntegrationContract(id);
  const { integratedApp } = appIntegrationData;

  return (
    <VStack className="gap-6">
      {/* TODO:BEの実装後にUserProvisioningフィールドを実装する */}
      <fieldset>
        <IntegrationFeatures />
      </fieldset>
      <Separator />
      {integratedApp.appId === APP_ID.CUSTOM_APP && (
        <>
          <CustomAppDefinition />
          <Separator />
        </>
      )}
      <fieldset disabled>
        <PricingBillingPlan />
      </fieldset>
      <Separator />
      {integratedApp.appId === APP_ID.CUSTOM_APP ? (
        <PlanDetailsCustomApp />
      ) : (
        <PlanDetails />
      )}
      {/* TODO:BEの実装後にManagementフィールドを実装する */}
      <Separator />
      <Authentication />
      <Separator />
      <fieldset disabled>
        <SamlSso />
      </fieldset>
      <Separator />
      <DangerZone />
    </VStack>
  );
}
